import { Flex, Text, useMediaQuery } from '@chakra-ui/react';
import { responsiveValue } from '../../../assets/style/defaultTheme';
import { theme } from '../../../assets/style/theme';

type Props = {
  data: any;
};

function ParticipationContentItemBoxed({ data }: Props) {

  const { flexBoxDirection } = responsiveValue;
  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  return (
    <>
    <Flex justify="space-between" pt="5" direction={flexBoxDirection}>
    {
    data.map((item:any, index:number) => (
      <Flex w={isMobile ? '100%' : '282px'} h={isMobile ? 'auto' : '228px'}textAlign="center"  key={index} border="1px" borderColor="b.dgr" borderRadius="16px" alignItems="center" pb={isMobile ? '8' : '0'} pt={isMobile ? '8' : '0'} mb={isMobile ? '4' : '0'}>
        <Text w="100%" dangerouslySetInnerHTML={ {__html: item } } lineHeight="1.8" color="b.dgr" fontSize="xl"></Text>
      </Flex>
      ))
    }
    </Flex>
    </>
    
  );
}

ParticipationContentItemBoxed.defaultProps = {
};

export default ParticipationContentItemBoxed;
